export const FIREBASE_SERVICE_PAGE_ID_NAME = 'vertical_bridge_service';
